import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, isRef as _isRef, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-h4" }, "Реестр граждан", -1)
const _hoisted_3 = { class: "d-flex mt-4 justify-end pa-3" }

import { computed, ref, Ref } from 'vue'
import {
  CitizensService,
  citizenGetFullname,
  citizenGetAddress,
  cardStatusName,
  MunicipalEntitiesService,
  Paging,
  AppAuthService,
  Permissions,
  CitizenOrderFields,
  OrderDirection,
} from '@prodcard/core'
import { Pagination } from '../../../../components'
import FilterBox from './FilterBox.vue'
import { usePaginator, Paginator, useAuthPermissions } from '../../../../mixins'
import { SearchParams } from '../interfaces'
import { createCtx, handleError, useWatcherSavedRef, monthsMock, yearsMock } from '../../../../helpers'
import { useRouter } from 'vue-router'
import { Workbook } from 'exceljs'
import { createSheetCitizens } from './createSheetCitizens'
import { saveWorkbook } from '../../../../common'
import { pickBy } from 'lodash'

interface FormattedCitizen {
  fullname: string
  birthdate: string
  document: {
    type: string
    info: string
  }
  address: string
  mo: string
  cardStatus: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CitizensListPage',
  props: {
    citizenService: {},
    municipalEntitiesService: {},
    authService: {}
  },
  setup(__props: any) {

const props = __props;


const router = useRouter()

const { currentMunicipalEntityId, hasPermissions } = useAuthPermissions(props.authService)
const hasView = computed(() => {
  return hasPermissions(Permissions.CITIZENS_VIEW)
})
const hasMeView = computed(() => {
  return hasPermissions(Permissions.ME_CITIZENS_VIEW)
})
const hasManage = computed(() => {
  return hasPermissions(Permissions.CITIZENS_MANAGE) || hasPermissions(Permissions.ME_CITIZENS_MANAGE)
})

const { paginator, count, getPageCount, getPageFrom } = usePaginator('citizenListPaginator')
const citizens: Ref<FormattedCitizen[]> = ref([])
const loading = ref(false)
const loadingTableToDownload = ref(false)

const headers = [
  { title: 'ФИО', key: 'fullname', sortable: false },
  { title: 'Дата рождения', key: 'birthdate', sortable: false },
  { title: 'Тип документа', key: 'document.type', sortable: false },
  { title: 'Данные документа', key: 'document.info', sortable: false },
  { title: 'Адрес регистрации', key: 'address', sortable: false },
  { title: 'MO', key: 'mo', sortable: false },
  { title: 'Cтатус карты', key: 'cardStatus', sortable: false },
]

const searchParams: Ref<SearchParams> = useWatcherSavedRef('citizenListParams', {
  search: '',
  municipalEntityId: !hasView.value && hasMeView.value ? currentMunicipalEntityId.value : undefined,
  cardStatus: undefined,
  month: undefined,
  year: undefined,
})

const updateSearchParams = (newSearchParams: SearchParams) => {
  searchParams.value = newSearchParams
  paginator.value.page = 1
  update(paginator.value, searchParams.value)
}

const update = (paginator: Paginator, filter: SearchParams) =>
  handleError(async () => {
    const from = getPageFrom.value
    const response = await fetchCitizens(filter, { from: from, count: paginator.per })

    citizens.value = response.items.map(({ citizen, document, cardStatus, municipalEntity }) => ({
      fullname: citizenGetFullname(citizen),
      address: citizenGetAddress(citizen),
      birthdate: new Date(citizen.birthdate).toLocaleDateString('ru-Ru'),
      document: document,
      cardStatus: cardStatusName(cardStatus),
      mo: municipalEntity,
      id: citizen.id,
    }))
    count.value = response.total
  }, loading)

const fetchCitizens = async (filter: SearchParams, paging?: Paging) => {
  const strippedFilter = pickBy(filter, v => v !== undefined && v !== null)
  const response = await props.citizenService.findAllWithInfo(createCtx(), {
    paging,
    filter: strippedFilter,
    order: { field: CitizenOrderFields.FULLNAME, direction: OrderDirection.ASC },
  })
  return response
}

const downloadTable = (filter: SearchParams) => {
  handleError(async () => {
    const workbook = new Workbook()
    const response = await fetchCitizens(filter)
    createSheetCitizens(workbook, 'Реестр граждан', response.items)

    await saveWorkbook(workbook, 'Реестр_граждан')
  }, loadingTableToDownload)
}

const openDetails = async (e: Event, val: { item: { value: string } }) => {
  if (hasManage.value) {
    await router?.push('/citizens/' + val.item.value + '/edit')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!

  return (_openBlock(), _createBlock(_component_v_data_table_server, {
    headers: headers,
    items: citizens.value,
    loading: loading.value,
    "items-length": _unref(count),
    "no-data-text": "Нет данных",
    "hide-default-footer": "",
    hover: "",
    "onUpdate:options": _cache[5] || (_cache[5] = ($event: any) => (update(_unref(paginator), _unref(searchParams)))),
    "onClick:row": openDetails
  }, {
    top: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (hasManage.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              to: "/citizens/new",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Создать")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(FilterBox, {
        class: "mt-5",
        "default-search-params": _unref(searchParams),
        "municipal-entities-service": _ctx.municipalEntitiesService,
        "month-items": _unref(monthsMock),
        "year-items": _unref(yearsMock),
        loading: loading.value,
        readonlyMe: !hasView.value && hasMeView.value,
        onUpdate: updateSearchParams
      }, null, 8, ["default-search-params", "municipal-entities-service", "month-items", "year-items", "loading", "readonlyMe"]),
      _createVNode(_unref(Pagination), {
        class: "my-5",
        modelValue: _unref(paginator),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(paginator) ? (paginator).value = $event : null)),
          _cache[1] || (_cache[1] = ($event: any) => (update(_unref(paginator), _unref(searchParams))))
        ],
        "page-count": _unref(getPageCount),
        disabled: loading.value || _unref(getPageCount) === 0
      }, null, 8, ["modelValue", "page-count", "disabled"])
    ]),
    bottom: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createTextVNode(" Итого: "),
          _createElementVNode("b", null, _toDisplayString(_unref(count)), 1)
        ])
      ]),
      _createVNode(_unref(Pagination), {
        modelValue: _unref(paginator),
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => (_isRef(paginator) ? (paginator).value = $event : null)),
          _cache[3] || (_cache[3] = ($event: any) => (update(_unref(paginator), _unref(searchParams))))
        ],
        "page-count": _unref(getPageCount),
        disabled: loading.value || _unref(getPageCount) === 0
      }, null, 8, ["modelValue", "page-count", "disabled"]),
      (_unref(hasPermissions)(_unref(Permissions).CITIZENS_TABLE_EXPORT))
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: "mt-5",
            color: "primary",
            variant: "outlined",
            "prepend-icon": "mdi-download-outline",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (downloadTable(_unref(searchParams)))),
            loading: loadingTableToDownload.value,
            disabled: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Скачать ")
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["items", "loading", "items-length"]))
}
}

})